import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { BryntumSchedulerPro, BryntumGrid } from "@bryntum/schedulerpro-react";
import SwivuSchedulerPro from "../../bryntum-lib/widget/extendingClasses/SwivuSchedulerPro.jsx";
import AdminLayout from "../layout/AdminLayout.jsx";
import { SwivuGrid } from "../../bryntum-lib/widget/extendingClasses/SwivuGrid.jsx";
import { Mask } from "@bryntum/schedulerpro";
import SwivuHomeModal from "../components/swivuHome/SwivuHomeModal.jsx";

BryntumSchedulerPro.instanceClass = SwivuSchedulerPro;
BryntumGrid.instanceClass = SwivuGrid;

const AdminRoutes = () => {
  useEffect(() => {
    // we require the app loader instance at several files, and we can't also export it from some outer scope since the export be may be loaded in agenda view
    window.SwivuAppLoaderInstance = Mask.mask(
      { text: "Loading Board...", progress: 0, maxProgress: 100 },
      document.body
    );
    window.SwivuAppLoaderInstance.hide();
    window.swivuInProgressNetworkRequests = 0;
  }, []);

  return (
    <>
      <SwivuHomeModal />
      <Switch>
        <Route path="/:main" component={AdminLayout} />
        {/* we need persist search param in case we have invitation id in url */}
        <Redirect
          from="*"
          to={{ pathname: "/main", search: window.location.search }}
        />
      </Switch>
    </>
  );
};

export default AdminRoutes;
